import { useEffect, useState } from "react";
import DataTable from "react-data-table-component";
import { OpticStockDistribution } from "./OpticStockDistribution";
import InputIconSearchPanelMultiSelection from "./InputIconSearchPanelMultiSelection";
import Tag from "./Tag";
import ButtonIconH from "./ButtonIconH";

export function ProductStockDistribution({
  productFamilyId,
  list,
  productFamilyName,
  columns,
  onProductChange,
  opticList,
}) {
  const [productList, setProductList] = useState(list);
  const [optionList, setOptionList] = useState([]);
  const [selectedOptionList, setSelectedOptionList] = useState([]);

  function handleStockChange(values, productId) {
    setProductList((prevList) =>
      prevList.map((e) => {
        if (e.idProductoAlbaran === productId) {
          return { ...e, opticas: values };
        }
        return e;
      }),
    );
  }

  function distributeEqually() {
    setProductList((prev) => {
      return prev.map((product) => {
        const stock = Math.abs(product.stock);

        const numOpticas = selectedOptionList.length;

        if (stock < numOpticas) {
          return product;
        }

        const divisibleQuantity = Math.floor(stock / numOpticas);

        return {
          ...product,
          opticas: product.opticas.map((optic) => {
            if (selectedOptionList.includes(optic.nombreOptica)) {
              return {
                ...optic,
                stock:
                  product.stock < 0 ? -divisibleQuantity : divisibleQuantity,
              };
            }
            return optic;
          }),
        };
      });
    });
  }

  function resetDistribution() {
    setProductList((prev) => {
      return prev.map((product) => {
        return {
          ...product,
          opticas: product.opticas.map((optic) => {
            return {
              ...optic,
              stock: 0,
            };
          }),
        };
      });
    });
  }

  useEffect(() => {
    onProductChange(productFamilyId, productList);
  }, [productList]);

  useEffect(() => {
    setOptionList(opticList.filter((e) => e.text !== "").map((e) => e.text));
  }, [opticList]);

  return (
    <>
      {productList.length > 0 && (
        <div style={{ marginBottom: "30px" }}>
          <div className="opt-table-title">
            {productFamilyName} ({list.length})
          </div>
          <div
            style={{
              display: "flex",
              flexDirection: "row",
              alignItems: "center",
              gap: 10,
              marginBottom: 10,
            }}
          >
            <div className="data-field" style={{ width: "600px" }}>
              <span className="label">Ópticas reparto equitativo</span>
              <InputIconSearchPanelMultiSelection
                size={0}
                tabIndex={53}
                type={"type-alphanum-ext"}
                options={optionList}
                selectedOptions={selectedOptionList}
                onChange={(e) => {
                  setSelectedOptionList(e);
                }}
              ></InputIconSearchPanelMultiSelection>
            </div>
            <ButtonIconH
              text="Aplicar reparto"
              onClick={distributeEqually}
              disabled={selectedOptionList.length === 0}
            ></ButtonIconH>
            <ButtonIconH
              text="Reiniciar reparto"
              onClick={resetDistribution}
            ></ButtonIconH>
          </div>
          {selectedOptionList.length > 0 && (
            <span style={{ fontWeight: "500", fontSize: 13 }}>
              Marcas seleccionadas: {selectedOptionList.length}
            </span>
          )}
          <div className="tag-content" style={{ padding: "10px 0 20px 0" }}>
            {selectedOptionList.map((e, i) => {
              return (
                <Tag
                  text={e}
                  key={i}
                  tagId={i}
                  onClick={(e) => {
                    setSelectedOptionList((prevBrands) =>
                      prevBrands.filter((brand) => brand !== e),
                    );
                  }}
                ></Tag>
              );
            })}
          </div>
          <div className="store-products-table delivery-note-table">
            <DataTable
              columns={columns}
              data={productList}
              className="custom-datatable custom-datatable-stock non-interactive"
              expandableRows
              expandableRowsComponent={({ data }) => (
                <div className="optic-list">
                  <OpticStockDistribution
                    opticList={data.opticas}
                    idProductoAlbaran={data.idProductoAlbaran}
                    maxStock={data.stock}
                    onStockChange={handleStockChange}
                  ></OpticStockDistribution>
                </div>
              )}
              noDataComponent="No hay productos disponibles."
              expandOnRowClicked={false}
              expandableRowExpanded={() => true}
            />
          </div>
        </div>
      )}
    </>
  );
}
